<template>
  <div>
    <ca-row>
      <ca-col>
        <ca-button @click="onEdit(selfEmployed.id)">Editar</ca-button>
        <ca-button
          class="ca-u-min-margin-left"
          @click="onDelete()">
          Excluir
        </ca-button>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col>
        <ca-page>
          <ca-async-content-wrapper
            :on-fetch="getSelfEmployed"
            :on-fetch-success="setSelfEmployed">
            <div v-if="selfEmployed">
              <ca-row>
                <ca-col>
                  <ca-heading :text="selfEmployed.selfEmployedName"></ca-heading>
                  <p>
                    <span class="ca-u-color-grey">
                      CPF:
                    </span>
                    <span>
                      {{ selfEmployed.cpf | caCpf }}
                    </span>
                  </p>
                </ca-col>
              </ca-row>
              <ca-row>
                <ca-col size="4">
                  <ca-field label="Autônomo possui matrícula vinculada ao eSocial?">
                    {{
                      selfEmployed.registrationOption
                        ? selfEmployed.registrationOption.description : ''
                    }}
                  </ca-field>
                </ca-col>
                <ca-col size="4">
                  <ca-field label="Matrícula do eSocial">
                    {{ selfEmployed.registration }}
                  </ca-field>
                </ca-col>
              </ca-row>
              <ca-row>
                <ca-col size="4">
                  <ca-field label="Função">
                    {{ selfEmployed.jobDescription.description }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="NIS">
                    {{ selfEmployed.nis }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Sexo">
                    {{ selfEmployed.gender.description }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Raça/Cor">
                    {{ selfEmployed.raceColor.description }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Grau de Instrução">
                    {{ selfEmployed.educationLevel.description }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Data de Nascimento">
                    {{ selfEmployed.dateOfBirth | caDate }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Categoria">
                    {{ selfEmployed.category.description }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Data do Início das Atividades">
                    {{ selfEmployed.admissionDate | caDate }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Alíquota ISS">
                    {{ selfEmployed.issAliquot }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Calcular IRRF">
                    {{ selfEmployed.calculateIrpf ? 'Sim' : 'Não' }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Calcular INSS">
                    {{ selfEmployed.calculateInss ? 'Sim' : 'Não' }}
                  </ca-field>
                </ca-col>

                <ca-col v-if="selfEmployed.calculateInss" size="4">
                  <ca-field label="Alíquota INSS">
                    {{ selfEmployed.inssAliquot }}
                  </ca-field>
                </ca-col>

                <ca-col v-if="selfEmployed.calculateInss" size="4">
                  <ca-field label="Quantidade de Dependentes">
                    {{ selfEmployed.dependentNumber }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Tipo Inscrição da Outra Empresa">
                    {{ selfEmployed.otherCompanyInfo.description }}
                  </ca-field>
                </ca-col>

                <ca-col
                  v-if="selfEmployed.otherCompanyInfo.name === 'TRIBUTE_DEDUCED_PARTIALLY_THERE'
                    || selfEmployed.otherCompanyInfo.name === 'TRIBUTE_DEDUCED_TOTALLY_THERE'"
                  size="4">
                  <ca-field label="Inscrição da Outra Empresa">
                    {{ selfEmployed.otherCompanyRegistrationType.description }}
                  </ca-field>
                </ca-col>

                <ca-col v-if="selfEmployed.insOutEmp" size="4">
                  <ca-field label="Base de cálculo do INSS na Outra Empresa">
                    {{ selfEmployed.otherCompanyRegistration }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Endereço">
                    {{ `${selfEmployed.street},
                    ${selfEmployed.streetNumber}
                    ${selfEmployed.neighborhood}` }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Cidade">
                    {{ selfEmployed.city }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Estado">
                    {{ selfEmployed.state.description }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Telefone">
                    {{ selfEmployed.phone }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Email">
                    {{ selfEmployed.email }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Situação no eSocial">
                    {{ selfEmployed.esocialStatus.description }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                </ca-col>
              </ca-row>
            </div>
          </ca-async-content-wrapper>
        </ca-page>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>

import {
  getSelfEmployed,
  deleteSelfEmployed,
} from './selfEmployedService';

export default {
  name: 'SelfEmployedListViewPage',
  data() {
    return {
      selfEmployed: null,
      selfEmployedId: this.$route.params.id,
    };
  },
  methods: {
    getSelfEmployed() {
      return getSelfEmployed(this.$route.params.id);
    },
    setSelfEmployed(selfEmployed) {
      this.selfEmployed = selfEmployed;
    },
    onEdit(id) {
      this.$router.push({ name: 'EditSelfEmployed', params: { id } });
    },
    onDelete() {
      this.$caConfirm({
        title: 'Excluir Autônomo',
        message: 'Você está prestes a excluir o registro de autônomo. Uma vez feita esta ação não poderá ser desfeita. Você tem certeza de que deseja excluir este registro?',
        onConfirm: () => {
          deleteSelfEmployed(this.selfEmployedId)
            .then(() => {
              this.$toaster.success('Autônomo excluído com sucesso.');
              this.$router.back();
            })
            .catch(() => {
              this.$toaster.error('Erro ao excluir o autônomo');
            });
        },
      });
    },
  },
};
</script>
